jQuery(document).ready(function($) {

	$('.hamburger').click(function(e){
		e.preventDefault();
		$(this).toggleClass('open');
		$('.mobile-menu__holder').fadeToggle('200');
	});

}); 